import { Validators } from "@angular/forms";
import { environment } from "src/environments/environment";
import { AwsService } from "../services/aws/aws.service";
import { User } from "./user-model";

export class Profile {
  id!: number;
  full_name: string = "";
  phone!: string;
  country_phone!: string;
  country_code_phone!: string;
  title!: string;
  web_site!: string;
  email!: string;
  description!: string;
  date_of_birthday!: string;
  //user_id!: number;
  avatar!: any;
  thumbnail: string = "";
  large_avatar: string = "";
  createdAt: string = "";
  user_role_type: string = "";
  user_role_name: string = "";
  email_confirmed: boolean = false;
  stripe_customer_token: string = "";
  stripe_account_token: string = "";
  count_left_credits: number = 0;
  iban: string = "";
  user: User;
  count_booking: number = 0;
  payouts_enabled: boolean = false;

  constructor(data?: Partial<Profile>) {
    if (data) {
      Object.assign(this, data);

      if (data.id !== undefined && this.thumbnail == "") {
        if (data.avatar) {
          this.thumbnail = AwsService.generate_link(
            data.avatar.formats != undefined &&
              data.avatar.formats != null &&
              data.avatar.formats.thumbnail != undefined
              ? data.avatar.formats.thumbnail.url
              : data.avatar.url
          );
          this.large_avatar = AwsService.generate_link(data.avatar.url);
        } else {
          this.thumbnail = environment.default_avatar;
          this.large_avatar = environment.default_cover;
        }
      }

      if (data.user !== undefined) {
        this.user = new User(data.user);
      }

      this.user_role_type = data.user_role_type;
      this.user_role_name = data.user_role_name;
      this.stripe_customer_token = data.stripe_customer_token;

      //this.user_id = data["user"] ? data["user"].id : "";
    }
  }

  short_full_name() {
    return this.full_name.length > 15
      ? this.full_name.substring(0, 15) + "..."
      : this.full_name;
  }

  static attributeToJson(item: any) {
    let user_role_type = "---";
    let user_role_name = "---";
    let stripe_customer_token = "";
    let stripe_account_token = "";

    let obj = item.attributes;
    obj["id"] = item.id;
    if (
      item.attributes.avatar != undefined &&
      item.attributes.avatar != null &&
      item.attributes.avatar.data != undefined &&
      item.attributes.avatar.data != null
    ) {
      obj["avatar"] = item.attributes.avatar.data.attributes;
    } else {
      obj["avatar"] = null;
    }

    obj["email_confirmed"] = false;

    if (obj["avatar"] != null) {
      if (
        obj["avatar"].formats != null &&
        obj["avatar"].formats != undefined &&
        obj["avatar"].formats.thumbnail != undefined &&
        obj["avatar"].formats != null &&
        obj["avatar"].formats.thumbnail != null
      ) {
        obj["thumbnail"] = AwsService.generate_link(
          obj["avatar"].formats.thumbnail.url
        );
      } else {
        obj["thumbnail"] = AwsService.generate_link(obj["avatar"].url);
      }
    } else {
      obj["thumbnail"] = environment.default_avatar;
    }

    obj["thumbnail"] =
      obj["avatar"] == null
        ? environment.default_avatar
        : AwsService.generate_link(obj["avatar"].url);

    if (item.attributes.user) {
      if (item.attributes.user.data != null) {
        let objUser = item.attributes.user.data.attributes;
        objUser["id"] = item.attributes.user.data.id;
        obj["user"] = objUser;

        obj["email_confirmed"] = objUser.confirmed;

        if (objUser.role) {
          if (objUser.role.data != null) {
            user_role_type = objUser.role.data.attributes.type;
            user_role_name = objUser.role.data.attributes.name;
          }
        }

        if (objUser.stripe) {
          if (objUser.stripe.data != null) {
            console.log(objUser.stripe.data.attributes);

            stripe_customer_token =
              objUser.stripe.data.attributes.customer_id != null &&
              objUser.stripe.data.attributes.customer_id != undefined &&
              objUser.stripe.data.attributes.customer_id != "undefined"
                ? objUser.stripe.data.attributes.customer_id
                : "";
            stripe_account_token =
              objUser.stripe.data.attributes.account_id != null &&
              objUser.stripe.data.attributes.account_id != undefined &&
              objUser.stripe.data.attributes.account_id != "undefined"
                ? objUser.stripe.data.attributes.account_id
                : "";
          }
        }
      } else {
        obj["user"] = null;
      }
    } else {
      obj["user"] = null;
    }

    obj["user_role_type"] = user_role_type;
    obj["user_role_name"] = user_role_name;
    obj["stripe_customer_token"] = stripe_customer_token;
    obj["stripe_account_token"] = stripe_account_token;

    return obj;
  }

  static get_title() {
    return "Ajouter un nouveau utilisateur";
  }

  static get_inputs() {
    return [
      {
        name: "full_name",
        type: "text",
        label: "Nom et prénom",
        readOnly: false,
      },
      {
        name: "iban",
        type: "text",
        label: "IBAN",
        readOnly: true,
      },
      {
        name: "phone",
        type: "phone",
        label: "Numéro téléphone",
        field_country: "country_phone",
        field_code: "country_code_phone",
        readOnly: false,
      },
      {
        name: "description",
        type: "textarea",
        label: "Description",
        readOnly: false,
      },
    ];
  }

  static get_form() {
    return {
      full_name: ["", Validators.required],
      iban: [""],
      phone: [""],
      description: [""],
      country_phone: [""],
      country_code_phone: [""],
    };
  }

  static get_relations() {
    return [
      {
        name: "avatar",
        label: "",
        component: "image",
        endpoint: "",
        belongTo: "",
        model: null,
        index: "",
        array: [],
        selected: "",
      },
      {
        name: "users",
        label: "les données d'accès",
        component: "button",
        endpoint: "users",
        belongTo: "profile",
        model: User,
        index: "id",
        array: [],
        selected: "",
      },
    ];
  }
}
